import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  setPaginationSecondValue,
  setPaginationFirstValue,
  setRecordsShow,
  setIsVisible,
  bonusTransaction,
} from "./bonusTransactionSlice.js";
import "jspdf-autotable";
import {
  convertToUSD,
  getDateTimeFormate,
  getIsOssino,
} from "../../sharedfiles/helper";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination.js";
import NoDataFound from "../Common/table/NoDataFound";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
const BonusTransaction = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [csvData, setCsvData] = useState([]);
  const [pdfBody, setPdfBody] = useState([]);
  const [payload, setPayload] = useState({});

  const isOssino = getIsOssino();

  const callApi = (pageNumber, itemsPerPage) => {
    dispatch(setIsVisible(false));
    dispatch(
      bonusTransaction(
        pageNumber - 1,
        itemsPerPage,
        localStorage.getItem("userId"),
        true //allTransactions
      )
    );
    setCsvData([]);
  };

  const headers = [
    [
      "Transaction ID",
      "Customer ID",
      "Bonus ID",
      "Released Date",
      "Bonus Code",
      "Locked Bonus",
      ...(isOssino ? ["Locked Bonus (USD)"] : []),
      "Unlocked Bonus",
      ...(isOssino ? ["Unlocked Bonus (USD)"] : []),
      "Transaction Amount",
      ...(isOssino ? ["Transaction Amount (USD)"] : []),
      "Transaction Reference",
      "Transaction Type",
      "Brand",
    ],
  ];

  const info = [
    "Showing Transaction ID",
    "Showing Customer ID",
    "Showing Bonus ID",
    "Showing Released Date",
    "Showing Bonus Code",
    "Showing Locked Bonus",
    ...(isOssino ? ["Showing Locked Bonus (USD)"] : []),
    "Showing Unlocked Bonus",
    ...(isOssino ? ["Showing Unlocked Bonus (USD)"] : []),
    "Showing Transaction Amount",
    ...(isOssino ? ["Showing Transaction Amount (USD)"] : []),
    "Showing Transaction Reference",
    "Showing Transaction Type",
    "Showing Brand",
  ];

  const exportPDF = () => {
    const title = "Bonus Transaction Report";

    exportPDFC(title, headers, pdfBody);
  };

  useEffect(() => {
    if (Object.keys(props.bonusTransactionData).length > 0) {
      const data =
        props.bonusTransactionData &&
        props.bonusTransactionData !== undefined &&
        Object.keys(props.bonusTransactionData).length > 0 &&
        props.bonusTransactionData.data &&
        Array.isArray(props.bonusTransactionData?.data) &&
        props.bonusTransactionData?.data.length > 0 &&
        props.bonusTransactionData?.data.map((p) => [
          p.id,
          p.userId,
          p.userBonusId,
          p.releasedDate ? getDateTimeFormate(p.releasedDate) : "-",
          p.bonusCode,
          p.lockedBonus,
          ...(isOssino
            ? [convertToUSD(p.lockedBonus, p.baseCurrencyRate, "USD")]
            : []),
          p.unlockedBonus,
          ...(isOssino
            ? [convertToUSD(p.unlockedBonus, p.baseCurrencyRate, "USD")]
            : []),
          p.transactionAmount,
          ...(isOssino
            ? [convertToUSD(p.transactionAmount, p.baseCurrencyRate, "USD")]
            : []),
          p.transactionReference,
          p.transactionType,
          p.brand,
        ]);
      const updatedData =
        data && data.length > 0
          ? [headers[0], info, ...data]
          : [headers[0], info, []];
      setCsvData(updatedData);
      setPdfBody(data);
    }
  }, [props.bonusTransactionData]);

  useEffect(() => {
    const paylaod = {
      pageNumber: props.activePages,
      itemsPerPage: props.paginationSecondValue,
    };
    setPayload(paylaod);
    callApi(1, 25);
  }, []);

  useEffect(() => {
    let mounting = true;
    const id = location.pathname.split("/")[2];
    const isToCall = props.userId !== id;
    if (mounting && isToCall) {
      dispatch(bonusTransaction(0, 25, id, true));
    }
    return () => (mounting = false);
  }, [location.pathname]);

  const bonusTxnCellClassName = [
    "text-sm font-mono whitespace-nowrap",
    "text-sm font-mono whitespace-nowrap",
    "text-sm font-mono whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm text-right font-medium whitespace-nowrap",
    ...(isOssino ? ["text-sm text-right font-medium whitespace-nowrap"] : []),
    "text-sm text-right font-medium whitespace-nowrap",
    ...(isOssino ? ["text-sm text-right font-medium whitespace-nowrap"] : []),
    "text-sm text-right font-medium whitespace-nowrap",
    ...(isOssino ? ["text-sm text-right font-medium whitespace-nowrap"] : []),
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
  ];
  const bonusTxnRowAccessors = [
    (item) => item.id,
    (item) => item.userId,
    (item) => item.userBonusId,
    (item) => (item.releasedDate ? getDateTimeFormate(item.releasedDate) : "-"),
    (item) => item.bonusCode,
    (item) => item.lockedBonus,
    ...(isOssino ? [(item) => convertToUSD(item.lockedBonus, item.baseCurrencyRate, "USD")] : []),
    (item) => item.unlockedBonus,
    ...(isOssino ? [(item) => convertToUSD(item.unlockedBonus, item.baseCurrencyRate, "USD")] : []),
    (item) => item.transactionAmount,
    ...(isOssino ? [(item) => convertToUSD(item.transactionAmount, item.baseCurrencyRate, "USD")] : []),
    (item) => item.transactionReference,
    (item) => (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-400">
        {item.transactionType}
      </span>
    ),
    (item) => item.brand,
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("bonusTransactionBonusTransaction", headers[0]);

  return (
    <>
      <div className="rounded-lg border bg-card shadow-lg">
        <div className='bg-gradient-to-r from-amber-50 to-orange-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
          <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Bonus Transactions</h2>
          <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>Complete history of bonus transactions and movements</p>
        </div>
        <div className="px-6 py-4 border-b bg-muted/20">
          <Vpagination
            data={props.bonusTransactionData?.data}
            totalRecords={props.bonusTransactionData.totalRecords}
            paginationFirstValue={props.paginationFirstValue}
            paginationSecondValue={props.paginationSecondValue}
            setPaginationFirstValue={setPaginationFirstValue}
            setPaginationSecondValue={setPaginationSecondValue}
            recordsShow={props.recordsShow}
            setRecordsShow={setRecordsShow}
            isVisible={props.isVisible}
            setIsVisible={setIsVisible}
            csvData={csvData}
            exportPDF={exportPDF}
            callApi={callApi}
            csvFileName={"Bonus Transaction Report"}
            payloadData={payload}
            columns={allColumns}
            onToggle={toggleVisibility}
            onReorder={reorder}
            onReset={resetToDefault}
          />
        </div>
        <div className="p-6">
          <div className="relative rounded-lg border bg-card overflow-hidden shadow-sm">
            <Table scrollKey="bonusTransactionBonusTransaction">
              <TableHeader>
                <TableRow>
                  {visibleIndices.map((origIdx) => (
                    <TableHead key={origIdx} className="whitespace-nowrap">{headers[0][origIdx]}</TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {props.bonusTransactionData?.data &&
                  props.bonusTransactionData.data.length > 0 ? (
                  props.bonusTransactionData.data.map((item, index) => (
                    <TableRow key={index}>
                      {visibleIndices.map((origIdx) => (
                        <TableCell key={origIdx} className={bonusTxnCellClassName[origIdx]}>
                          {bonusTxnRowAccessors[origIdx](item)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <NoDataFound colspan={visibleIndices.length} />
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};
function mapStateToProps(state) {
  return {
    activePages: state.bonusTransactionSlice.activePages,
    paginationFirstValue: state.bonusTransactionSlice.paginationFirstValue,
    paginationSecondValue: state.bonusTransactionSlice.paginationSecondValue,
    userId: state.playersearch.userId,
    recordsShow: state.bonusTransactionSlice.recordsShow,
    isVisible: state.bonusTransactionSlice.isVisible,
    bonusTransactionData: state.bonusTransactionSlice.bonusTransactionData,
  };
}
export default connect(mapStateToProps)(BonusTransaction);
